var DynamicElectionRoutes = function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("dynamicElection", {
        url: "/elections/*name",
        controller: "DynamicElectionRoutingController",
        templateUrl: function (params) {
            var dirPath = params.name;
            var dirs = dirPath.split("/");
            var url = __styleEnv__ + "customizations/Default/elections/" + dirs[0] + ".html";
            return url;
        },
        data: {
            fullHeight: true,
            title: "dynamic"
        }
    });
};

DynamicElectionRoutes.$inject = ["$stateProvider", "$urlRouterProvider"];
export default DynamicElectionRoutes;
